/**
 * Created by kb on 2017/11/17.
 */
{
  /**
   * String 类型的方法拓展 判断字符换是否为空或null
   * @returns {boolean}
   */
  String.prototype.notBlank = function () {
    return this != undefined && $.trim(this) != "" && this != null;
  }

  /**
   * 日期时间字符串格式化成标准的时间
   * @param IsTime
   * @returns {string}
   */
  String.prototype.formatDate = function (IsTime) {
    return IsTime ? this.toString().substr(0, 19).replace(/[-]/g, "/").replace(/[T]/g, " ") : this.toString().substr(0, 10).replace(/[-]/g, "/");
  }
}



// WEBPACK FOOTER //
// ./src/commonJs/objExtend/String_E.js